import { Box, Flex } from '@chakra-ui/react';
import Menu from 'components/Menu';
import React from 'react';
import { Outlet } from 'react-router-dom';

const Layout: React.FC = () => {
  return (
    <Flex minH="100vh" direction={{ base: 'column', md: 'row' }} bg="#f6efe7">
      <Menu />
      <Box flex={1} minW={0}>
        <Outlet />
      </Box>
    </Flex>
  );
};

export default Layout;
